import  styles from './SurkovInfo.module.css'
import React, {use, useEffect, useRef, useState} from "react";
import useApiQuery from "../ApiQuery/UseApiQuery";
import WaitLoader from "../WaitLoader/WaitLoader";
import imSim from '../Img/Surkov/sim.jpg'
import bkSber from '../Img/Surkov/bkSber.png'
import bkAlpha from '../Img/Surkov/bkAlpha.png'
import bktBank from '../Img/Surkov/bkTBank.png'
import InputItem from "../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../FormTemplate/ErrorLineItem/ErrorLineItem";
import MainFormTemplate from "../FormTemplate/MainFormTemplate/MainFormTemplate";

declare global {
    interface Window {
        Telegram: any;
    }
}

interface ILineX
{
    title:string
    text:string
    type?:number
}
interface IUserInfo
{
    needCapture: boolean
    ctn?: string
    chatId?:string
    cardInfo?:boolean
    userId:string
    xLine?: ILineX[]
    yLine?:ILineX[]
    sLine?:ILineX[]
    deadDay:string
}
export default function SurkovService()
{

    const [initDataStr, setInitDataStr] = useState<any>()

    const [msgMode, setMsgMode] = useState<'MAX'|'TELEGRAM'|undefined>('MAX')

    const stateRef = useRef<ErrorLineItemRef>(null)

    const [userId, setUserId] = useState<string>()
//    const [userId, setUserId] = useState<string>("33205681")
//    const [userId, setUserId] = useState<string>("419762953")

    const [userInfo, setUserInfo] = useState<IUserInfo>()

    const [ctn, setCtn] = useState("")
    const [validCtn, setValidCtn] = useState(false)

    const [initData, setInitData]= useState("-")

    const dataUserInfo = useRef<{
        userId: string,
        type:string
    }>(null)
    const [ldrUserInfo,rsUserInfo,exUserInfo] = useApiQuery("/surkov/user/check","post",dataUserInfo);


    const dataUserCapture = useRef<{
        userId: string
        ctn: string
        type: string
    }>(null)
    const [ldrUserCapture,rsUserCapture,exUserCapture] = useApiQuery("/surkov/user/capture","post",dataUserCapture);


    const [mode, setMode]= useState(0)

    useEffect(() => {
        console.log("init tg")

        const queryParams = new URLSearchParams(window.location.search)
        const mode = queryParams.get('mode')




        console.log("mode : ", mode)

        // Проверяем, доступен ли объект Telegram Web App
        if (mode?.match(/telegram/ui) && window.Telegram && window.Telegram.WebApp) {
            setMsgMode('TELEGRAM')
            // Инициализируем Telegram Web App
            window.Telegram.WebApp.ready();

            // Получаем initData
            const initData = window?.Telegram?.WebApp.initData;
            console.log(`init data ${initData}`)
            setInitData(initData)
            //window?.Telegram?.WebApp.showAlert("Fuck")
            // Парсим данные пользователя
            const x = telegramParseInitData(initData);
            if(x?.user?.id) {
                setUserId(x?.user?.id)
                return
            }
            setMode(1)
            //window.Telegram.WebApp.sendData("{'id':5}")

            //setUserData(user);
        }


        if (mode?.match(/max/ui) && window.WebApp.initData ) {
            setMsgMode('MAX')
            // Инициализируем Telegram Web App

            // Получаем initData
            const initData = window.WebApp.initData
            console.log(`max init data ${initData}`)
            setInitData(initData)
            //window?.Telegram?.WebApp.showAlert("Fuck")
            // Парсим данные пользователя
            const x = maxParseInitData(initData);
            if(x?.user?.id) {
                setUserId(x?.user?.id)
                return
            }
            setMode(1)
            //window.Telegram.WebApp.sendData("{'id':5}")

            //setUserData(user);
        }


    }, []);

    useEffect(()=>{
        console.log("userId", userId)
        if(userId)loadUserInfo()
    },[userId])

    useEffect(()=>{
        if(userInfo && userInfo?.needCapture)
        {
            setMode(1)
            return
        }

    },[userInfo])

    const telegramParseInitData = (initData: string) => {
        const params = new URLSearchParams(initData);
        try {
            const  user = params.get('user')
            const x = {
                user: JSON.parse(user ? user : "{}"),
                hash: params.get('hash'),
                auth_date: params.get('auth_date'),
                start_param: params.get('start_param'),
                chat_type: params.get('chat_type'),
                chat_instance: params.get('chat_instance'),
            }
            return x

        } catch (e)
        {}
        return  null
    };
    const maxParseInitData = (initData: string) => {
        const params = new URLSearchParams(initData);
        try {
            const  user = params.get('user')
            const chat = params.get('chat')
            const x = {
                user: JSON.parse(user ? user : "{}"),
                hash: params.get('hash'),
                auth_date: params.get('auth_date'),
                start_param: params.get('start_param'),
                chat: JSON.parse(chat ? chat : "{}"),
            }
            return x

        } catch (e)
        {}
        return  null
    };

    const loadUserInfo =()=>{
        if(!userId || !msgMode)return
        dataUserInfo.current = {
            userId: userId,
            type: msgMode
        }
        exUserInfo().then((e)=>{
            if(e?.success)
            {
                setMode(0)
                setUserInfo(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)
            setMode(2)
        })
    }

    const handleCaptureCtn = () =>{
        const ctnReg = ctn?.match(/[0-9]{10}$/ui)
        if(! ctnReg || !userId || !msgMode) return
        dataUserCapture.current = {
            ctn: ctnReg[0],
            userId: userId,
            type: msgMode
        }
        exUserCapture().then((e)=>{
            if(e?.success)
            {
                if(stateRef.current)stateRef.current.show("Номер привязан к чату",false,0)
                setValidCtn(false)
                setTimeout(()=>{
                    setMode(0)
                    loadUserInfo()
                }, 3000)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,5000)
        })

    }
    const buildNeedCapture = ()=>{
        if(mode !== 1) return null
        return (
            <div className={styles.capCont}>
                <div className={styles.capTitle}>Введите Ваш номер для привязки</div>
                <InputItem
                    mode={"ei"}
                    val={ctn}
                    title={""}
                    info={"Ваш номер"}
                    regExp={/(8|\+7|^)9[0-9]{9}$/ui}
                    type={"numeric"}
                    maxLen={12}
                    placeHolder={"XXXXXXXXXX"}

                    onChange={(e)=>{
                        if(e?.match(/(8|\+7|^)9[0-9]{9}$/ui)){
                            setCtn("+7"+e?.slice(-10))
                            setValidCtn(true)
                            return
                        }
                        setValidCtn(false)
                        setCtn(e)
                    }}

                />
                <div className={styles.stateCont}>
                    <ErrorLineItem ref={stateRef}></ErrorLineItem>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            disabled={!validCtn}
                            onClick={handleCaptureCtn}
                    >Привязать</button>
                    <div className={styles.ldrNew}>
                        <WaitLoader loading={ldrUserCapture} api={rsUserCapture} onlyLoading={true}>

                        </WaitLoader>

                    </div>


                </div>

            </div>
        )
    }

    const buildBank = ()=>{
        if(!userInfo?.cardInfo) return null
        return (
            <div>
                <div className={styles.bkCont}>
                    <div className={styles.bkTitle}>Карта Сбер банк</div>
                    <div className={styles.bkRow}>
                        <div className={styles.bkImg}>
                            <img src={bkSber}></img>
                        </div>
                        <div>
                            4276-4400-1109-5228
                        </div>
                    </div>
                </div>
                {false &&
                    <div className={styles.bkCont}>
                        <div className={styles.bkTitle}>Карта Альфа банк</div>
                        <div className={styles.bkRow}>
                            <div className={styles.bkImg}>
                                <img src={bkAlpha}></img>
                            </div>
                            <div>
                                2200-1545-4868-4223
                            </div>
                        </div>
                    </div>
                }
                <div className={styles.bkCont}>
                    <div className={styles.bkTitle}>Карта Т-банк</div>
                    <div className={styles.bkRow}>
                        <div className={styles.bkImg}>
                            <img src={bktBank}></img>
                        </div>
                        <div>
                            2200-7004-0769-5864
                        </div>
                    </div>
                </div>
                <div className={styles.bkRound}>Пожалуйста не округляйте итоговую сумму! Данный номер <span>+79039315511</span> привязан к банку Сбер и Т-Банк</div>


            </div>
        )
    }

    const buildPayMethod = ()=>{
        if(!userInfo)return null
        return(
            <div className={styles.payCont}>
                <div className={styles.payText}>Уважаемый абонент! Просим оплатить задолженность за услуги связи Билайн до <span>{userInfo?.deadDay}</span> числа текущего месяца.</div>
                {buildBank()}
                <div className={styles.btnContNew}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>setMode(1)}
                    >Привязать другой номер</button>


                </div>



            </div>
        )
    }


    const buildError = () =>{
        if(mode !==2) return null
        return (
            <div className={styles.payCont}>
                <div className={styles.errText}>Уважаемый абонент! Информация по задолженности по Вашим номерам отсутствует</div>
                <div className={styles.btnContNew}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>setMode(1)}
                    >Привязать другой номер</button>


                </div>



            </div>
        )
    }

    const buildInfo = ()=>{

        if(mode !==0 )return null
        const s = userInfo?.sLine?.map((item,idx)=>{
            return(
                <div className={styles.sCont} key={idx}>
                    <div className={styles.xTitle}>{item?.text}</div>
                </div>
            )


        })

        const x = userInfo?.xLine?.map((item,idx)=>{
            return(
                <div className={styles.xCont} key={idx}>
                    <div className={styles.xTitle}>{item?.title}</div>
                    <div className={styles.xText}>{item?.text}</div>
                </div>
            )


        })

        const y = userInfo?.yLine?.map((item,idx)=>{
            return(
                <div className={styles.yCont} key={idx}>{item?.text}</div>
            )
        })

        return(
            <>
                <div className={styles.xMainCont}>{s}</div>
                <div className={styles.xMainCont}>{x}</div>
                <div className={styles.yMainCont}>{y}</div>
                {buildPayMethod()}
            </>
        )
    }

    return(
        <div className={styles.mainCont}>
            <WaitLoader loading={ldrUserInfo } api={rsUserInfo} onlyLoading={true}>
                <div className={styles.mCont}>
                    <div className={styles.imCont}>
                        <img src={imSim}></img>
                    </div>

                    {buildNeedCapture()}
                    {buildInfo()}
                    {buildError()}
                </div>


            </WaitLoader>

        </div>
    )
}